/**
 * 対象の階層に応じてタグのリストを取得する関数。
 *
 * @param {number} currentDepth - 現在の階層。
 * @param {Array} tagSets - 階層0のタグセットの配列。
 * @param {Object} tags - 各階層のタグを含むオブジェクト。
 * @returns {Array} 現在の階層で表示するタグのリスト。
 */
const getCurrentLevelTags = (currentDepth, tagSets, tags) => {
  if (currentDepth === 0) {
    return tagSets;
  }
  return tags && tags[`level${currentDepth}`]
    ? tags[`level${currentDepth}`]
    : [];
};

export default getCurrentLevelTags;
